export default __webpack_public_path__ + "static/media/o-icon.81c2bc33.svg";